import { Button, Heading, Text } from '@radix-ui/themes';
import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <section className="mx-auto flex max-w-md flex-col items-center gap-3 py-16 text-center">
      <Heading as="h1" size="6">
        Page not found
      </Heading>
      <Text color="gray" size="2">
        The page you are looking for does not exist or has moved.
      </Text>
      <Button asChild variant="soft" mt="2">
        <Link to="/submissions">Go to submissions</Link>
      </Button>
    </section>
  );
}
